import { render, staticRenderFns } from "./modelList.vue?vue&type=template&id=b9bed6b0&scoped=true&"
import script from "./modelList.vue?vue&type=script&lang=js&"
export * from "./modelList.vue?vue&type=script&lang=js&"
import style0 from "./modelList.vue?vue&type=style&index=0&id=b9bed6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bed6b0",
  null
  
)

export default component.exports